module.exports = __webpack_public_path__ + "img/aggregators.c59f1be1.svg";